export default __webpack_public_path__ + "static/media/complementary--weekends-or-holidays--g1.75bb96df.png";